export enum NewBuildingDeal {
    LAW_214 = 'LAW_214',
    ESCROW = 'ESCROW'
}
